// extracted by mini-css-extract-plugin
export default {"bold":"OrgOption_bold__HRrCl","text":"OrgOption_text__gmJ8R","light":"OrgOption_light__cNGz2"};